var _defs, _path, _path2, _path3, _path4, _rect, _path5, _path6, _path7, _polygon;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLudvigCoLogoRgbWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "LOGO",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 514.95 56.07",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "LUDVIG_CO_LOGO_RGB_WHITE") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M650.24,270.79c-15.85,0-28.42,11.65-28.42,28,0,16.47,12.57,28.11,28.42,28.11s28.42-11.64,28.42-28.11C678.66,282.44,666,270.79,650.24,270.79Zm-.07,42.75c-7.74,0-13.79-5.29-13.87-14.79-.07-9.34,6.05-14.63,13.94-14.63,7.58,0,13.94,5.29,13.94,14.63C664.18,308.25,657.82,313.54,650.17,313.54Z",
    transform: "translate(-163.71 -270.79)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M587.51,313.54c-7.35,0-13.48-5.29-13.4-14.71-.08-9.42,6-14.71,13.17-14.71,5.59,0,9.73,2.76,11.11,7h15c-2.53-14.09-14.48-20.3-25.81-20.3-15.4,0-28,11.65-28,28s12.56,28,28,28c11.64,0,23.59-5.67,26.12-19.53H598.77C597.39,311.31,593.25,313.54,587.51,313.54Z",
    transform: "translate(-163.71 -270.79)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M534.63,297H522.37a30.63,30.63,0,0,1-.53,7.35l-10.5-12.1c-2.3-2.68-3.21-3.75-3.21-5.74a3.86,3.86,0,0,1,4-3.83c2.51,0,4.27,1.51,4.44,4.45,0,0,14.94,0,14.94,0-1.84-11.34-10.87-16.32-19.15-16.32-10.8,0-18.68,6.9-18.68,15.94a13.48,13.48,0,0,0,2.52,8.19,17.41,17.41,0,0,0-8.73,15.63c0,10.57,8.5,16.31,19.53,16.31a28.6,28.6,0,0,0,14.56-3.75l2.75,3h16.47l-10.34-11.88A30.86,30.86,0,0,0,534.63,297Zm-25.05,18.38c-5.05,0-8.35-2.91-8.35-7a6.57,6.57,0,0,1,2.22-5.13L514,314.68A12.77,12.77,0,0,1,509.58,315.37Z",
    transform: "translate(-163.71 -270.79)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M435.39,296.22v12.34H449c-2.07,3.83-6,5.05-10.5,5.05-7.81,0-13.94-5.36-13.86-14.78-.08-9.42,6.05-14.71,13.17-14.71,5.9,0,10,2.76,11.41,7h15c-2.53-14.09-14.48-20.3-26.12-20.3-15.4,0-28,11.65-28,28s12.56,28,28,28c11.64,0,25.89-6.43,26.19-25.43a46.42,46.42,0,0,0-.3-5.21Z",
    transform: "translate(-163.71 -270.79)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 221.44,
    y: 0.77,
    width: 14.02,
    height: 54.54
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M348.69,305.19a45.92,45.92,0,0,0-1.77,5.2c-.53-1.76-.84-2.52-1.83-5.2L332,271.56H317l22,54.54h15.85l21.91-54.54H361.78Z",
    transform: "translate(-163.71 -270.79)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M285.49,271.56H263.28V326.1h22.21c17.31,0,29.95-11.65,29.95-27.35S302.8,271.56,285.49,271.56Zm.69,40.9H277.3V285.19h9c8.35,0,14.71,5.29,14.71,13.56C301,307.18,294.61,312.46,286.18,312.46Z",
    transform: "translate(-163.71 -270.79)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M237,301.89c0,6.82-3.14,11.34-9.35,11.34s-9.34-4.52-9.34-11.34V271.56h-14V303.5c0,15.09,10,23.36,23.36,23.36S251,318.59,251,303.5V271.56H237Z",
    transform: "translate(-163.71 -270.79)"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "14.02 0.77 0 0.77 0 55.3 33.7 55.3 33.7 41.67 14.02 41.67 14.02 0.77"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLudvigCoLogoRgbWhite);
export default __webpack_public_path__ + "static/media/LUDVIG_CO_LOGO_RGB_WHITE.fe6c48479970063d6b395ff151e3f9ba.svg";
export { ForwardRef as ReactComponent };